exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle-el[data-v-3ee0cbdc] {\n  display: none;\n}\n.container-align[data-v-3ee0cbdc] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.card-status-center[data-v-3ee0cbdc]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n}\n", ""]);

// exports
